import classNames from 'classnames/bind';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import BackButton from './BackButton';
import type { SubNavSection } from './Header';
import SubnavigationItem from './SubnavigationItem';
import SubnavigationTitle from './SubnavigationTitle';

import styles from './Header.module.scss';

const cx = classNames.bind(styles);

type SubnavigationProps = {
  id: string;
  sections: SubNavSection[];
  isOpen: boolean;
};

const Subnavigation = (props: SubnavigationProps): React.JSX.Element | null => {
  const { id, isOpen, sections } = props;
  const { sitecoreContext } = useSitecoreContext();
  const { pageEditing } = sitecoreContext;

  if (pageEditing || !sections || sections?.length < 1) return null;

  const whiteSection: React.JSX.Element[] = [];
  const greySection: React.JSX.Element[] = [];

  let sectionElement: React.JSX.Element;

  sections.forEach((section, i) => {
    sectionElement = (
      <section key={i} className={cx({ 'header__subnavigation-section': true })}>
        <SubnavigationTitle
          title={section.title}
          link={section.link}
          isOpen={isOpen}
          parentId={id}
          datasourceLanguage={section.datasourceLanguage}
        />
        <ul>
          {section.subNavSectionsAndLinks?.map((item, j) => (
            <SubnavigationItem index={j} isOpen={isOpen} item={item} key={`subnavigation-item-${j}`} parentId={id} />
          ))}
        </ul>
      </section>
    );

    if (section.greySection?.value) {
      greySection.push(sectionElement);
    } else {
      whiteSection.push(sectionElement);
    }
  });

  return (
    <div id={id} className={cx('header__subnavigation', { 'header__subnavigation--open': isOpen })}>
      <div className={cx('container', 'header__subnavigation-container')}>
        <div className={cx('row', 'header__subnavigation-row')}>
          <div className={cx('col', 'header__subnavigation-col')}>
            <BackButton controls={id} visibile={isOpen} />
            {whiteSection}
          </div>
          <div className={cx('col', 'header__subnavigation-col', 'header__subnavigation--gray')}>{greySection}</div>
        </div>
      </div>
    </div>
  );
};
export default Subnavigation;
